import { createContext, useContext, useReducer } from 'react';
import { PurchaseSearchState, PurchaseSearchReducer, ACTION_TYPES } from './purchase-search-reducer';
import { IPurchasePageRequest } from '../../../../model/scp/purchase/request/purchase-paged-request';
import { PurchaseSortField } from '../../../../model/scp/purchase/purchase-sort-field';
import { SortDirection } from '../../../../model/scp/base/sort-direction';

const PurchaseSearchContext = createContext<PurchaseSearchState | undefined>(undefined);
const PurchaseSearchDispatchContext = createContext({} as any);

const PurchaseSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: PurchaseSearchState = {
        modality: [],
        situation: [],
        disputeMode: [],
        parameters: {
            page: 0,
            pageSize: 100,
            sortBy: PurchaseSortField.UpdatedDate,
            sortDirection: SortDirection.Descending
        } as IPurchasePageRequest,
        searchTrigger: 0,
    };

    const [state, dispatch] = useReducer(PurchaseSearchReducer, initialState);

    return (
        <PurchaseSearchContext.Provider value={state}>
            <PurchaseSearchDispatchContext.Provider value={dispatch}>
                {children}
            </PurchaseSearchDispatchContext.Provider>
        </PurchaseSearchContext.Provider>
    );
}

const usePurchaseSearchState = () => {
    const context = useContext(PurchaseSearchContext);
    if (context === undefined) {
        throw new Error('usePurchaseSearchState must be used within a PurchaseSearchProvider');
    }
    return context;
}

const usePurchaseSearchDispatch = () => {
    const context = useContext(PurchaseSearchDispatchContext);
    if (context === undefined) {
        throw new Error('usePurchaseSearchDispatch must be used within a PurchaseSearchProvider');
    }
    return context;
}

export { PurchaseSearchProvider, usePurchaseSearchDispatch, usePurchaseSearchState, ACTION_TYPES };
